import * as types from './types';
import { CLEAR_RECOGNITION } from '../../../app-dux/recognition/types';

/*******************************************************************************
 * Initial state
 */
 const initialState = {
     message: '',
     selectedEcard: {},
     private: false
};

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {
    switch ( action.type ) {
        case types.SET_MESSAGE: {
            return {
                ...state,
                message: action.message
            };
        }
        case types.SET_SELECTED_ECARD: {
            return {
                ...state,
                selectedEcard: action.ecard
            };
        }
        case types.SET_PRIVATE_REC: {
            return {
                ...state,
                private: action.privateRec
            };
        }
        case CLEAR_RECOGNITION: {
            return initialState;
        }
        default:
            return state;
    }
}
